var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ACarousel",
    {
      ref: "swiperTop",
      staticClass: "swiper",
      attrs: { options: _vm.swiperOptionTop },
    },
    _vm._l(_vm.list, function (item, key) {
      return _c(
        "ACarouselSlide",
        { key: key, attrs: { index: key } },
        [
          _c("AImage", { attrs: { img: item } }),
          _vm._v(" "),
          item && item.alt
            ? _c("span", { staticClass: "carousel-caption" }, [
                _c("div", { staticClass: "group-description-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "description-icon" },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "icon",
                        attrs: { icon: "camera", "fixed-width": "" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v("\n          " + _vm._s(item.alt) + "\n        "),
                  ]),
                ]),
              ])
            : _vm._e(),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }